"use client";
import React, { useEffect } from "react";
import { GroupHeader } from "../../../ui/Headers";
import useEmblaCarousel from "embla-carousel-react";
import AutoScroll from "embla-carousel-auto-scroll";
import { Service } from "../../design1/components/OurServices";
import { newData } from "../../design1/components";
import { EmblaCarouselType } from "embla-carousel";
import { ButtonControls } from "../../design1/components/Announcement";
import StyledWraper from "./StyledWraper";
import { Config } from "src/types";
import { useGroupedServices } from "src/app/hooks/useGroupServices";

const Services = (config: Config) => {
  const services = config.companyServices;
  if (config.companyServices?.length === 0 || services?.[0] === "N/A") {
    return null;
  }
  return (
    <section className="py-14 xs:pb-8">
      <div className="wrapper">
        <GroupHeader
          max={1000}
          subheader="Discover the variety of services and solutions we offer to fulfill your needs."
          header="What We Can Do for You"
        />
      </div>

      <OurServices {...config} />
    </section>
  );
};
export default Services;

const OurServices = (config: Config) => {
  return (
    <div className="overflow-hidden mt-4">
      <SliderParent data={config?.companyServices} />
    </div>
  );
};

const Slider: React.FC<{
  direction: "rtl" | "ltr";
  data: Service[];
  emblaApiRef: (api: EmblaCarouselType) => void;
}> = ({ data, emblaApiRef }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, align: "start" },
    [AutoScroll({ playOnInit: false, speed: 2 })]
  );

  useEffect(() => {
    if (emblaApi) emblaApiRef(emblaApi);
  }, [emblaApi, emblaApiRef]);

  return (
    <div className="relative left-4" ref={emblaRef}>
      <div className={`flex `}>
        {data.map((item, index) => (
          <div
            key={index}
            className="transform-none sm:!w-[100%] lg:w-[50%] w-[33.3333%]  h-full shrink-0 pr-8"
          >
            <StyledWraper className="w-full select-none" key={index}>
              <Card {...item} />
            </StyledWraper>
          </div>
        ))}
      </div>
    </div>
  );
};

export const SliderParent: React.FC<{ data?: string[] }> = ({ data }) => {
  const { slidersData, setEmblaApi, scrollPrev, scrollNext } =
    useGroupedServices(data, newData);
  return (
    <div className="flex relative flex-col pb-4 gap-10">
      <button
        onClick={scrollPrev}
        className="absolute top-1/2 z-[30] cursor-pointer rotate-[180deg] left-0 transform -translate-y-1/2"
      >
        <ButtonControls />
      </button>
      <button
        onClick={scrollNext}
        className="absolute top-1/2 z-[30] right-0 transform -translate-y-1/2"
      >
        <ButtonControls />
      </button>
      {slidersData.map((sliderData, index) => (
        <Slider
          key={index}
          data={sliderData}
          direction="rtl"
          emblaApiRef={setEmblaApi(index)}
        />
      ))}
    </div>
  );
};

export const Card: React.FC<Service> = ({ icon, header, text }) => {
  return (
    <div
      style={{ boxShadow: "0px 4px 50px 0px #2121210D" }}
      className="flex w-full  gap-3 min-h-[8.5rem] rounded-2xl bg-white p-4"
    >
      <div className="h-[3.5rem] border-themeColor border select-none bg-[rgba(var(--primary-color-rgb),0.1)] aspect-square flex items-center font-semibold justify-center rounded-lg">
        <span className="size-[4rem] text-themeColor grid place-items-center">
          {icon}
        </span>
      </div>
      <div className="item">
        <h4 className="text-themeColor h6  !font-bold mb-2">{header}</h4>
        <p className="text-secondar text-black text-[14px] select-none">{text}</p>
      </div>
    </div>
  );
};
